<div class="dettaglio__mobile">
  <div class="collage">
    <div class="tipiWrapper">
      <div
        class="tipovisita"
        id="tipovisita__{{ idx }}"
        *ngFor="let tipovisita of tipivisite; let idx = index"
        [ngStyle]="{
          background:
            colori && colori.sfondoCardItems ? colori.sfondoCardItems : 'auto'
        }"
      >
        <div
          class="image__container"
          *ngIf="
            !tipovisitaSelezionata || tipovisita.id != tipovisitaSelezionata.id
          "
        >
          <div class="tipologie">
            <app-tipologie [tipologie]="tipovisita.tipo"></app-tipologie>
          </div>
          <img
            src="{{ tipovisita.imgsrc }}"
            alt="Immagine copertina visita {{ tipovisita.nome }}"
            title="Immagine copertina visita {{ tipovisita.nome }}"
            class="image__img"
            (click)="apriDettaglioTipovisita(idx, tipovisita)"
          />
          <div class="instant__wrapper">
            <div
              class="instant booking"
              *ngIf="
                tipovisita.totVisite > 0 && tipovisita.confermabile !== '1'
              "
            >
              {{ "base.conferma_istantanea" | translate }}
              <span class="material-symbols-outlined"> bolt </span>
            </div>
            <div
              class="instant pcantina"
              *ngIf="
                tipovisita.totVisite > 0 &&
                tipovisita.pagacantina_visita === '1'
              "
            >
              {{ "base.paga_sc" | translate }}
              <span class="material-symbols-outlined"> credit_card </span>
            </div>
            <div class="instant promo" *ngIf="tipovisita.visiteInPromo !== '0'">
              PROMO
            </div>
          </div>
        </div>
        <div
          class="content__container"
          *ngIf="
            !tipovisitaSelezionata || tipovisita.id != tipovisitaSelezionata.id
          "
        >
          <div>
            <div class="orario-item" *ngIf="collegate">
              {{ tipovisita.cantina }} ({{ tipovisita.regione }})
            </div>
            <div class="title">
              {{ sistemaTitolo(tipovisita.titolo) }}
            </div>
            <div
              class="subtitle"
              *ngIf="tipovisita.sottotitolo && tipovisita.sottotitolo !== ''"
            >
              {{ tipovisita.sottotitolo }}
            </div>
          </div>
          <div class="space__between__container">
            <div class="info__bottom__container">
              <div
                class="orario-item"
                *ngIf="tipovisita.offsetOreCancella != 0"
              >
                <span class="material-symbols-outlined icon">
                  check_circle
                </span>
                {{ "base.cancellazione_gratuita" | translate }}
              </div>
              <div class="orario-item" *ngIf="tipovisita.range_attivi === '1'">
                <span class="material-symbols-outlined icon"> person_add </span>
                {{ "base.range_prezzi" | translate }}
              </div>
              <div
                class="price__container"
                *ngIf="tipovisita.nascondi_prezzo === '0'"
              >
                <div class="from" *ngIf="chooseCostoMinimo(tipovisita) > 0">
                  {{ "base.a_partire" | translate }}
                </div>
                <div class="price">
                  <span *ngIf="chooseCostoMinimo(tipovisita) > 0">€</span>
                  <span *ngIf="chooseCostoMinimo(tipovisita) > 0">
                    {{ chooseCostoMinimo(tipovisita) | number : "1.2-2" }}
                  </span>
                  <span *ngIf="chooseCostoMinimo(tipovisita) == 0">
                    {{ "base.gratis" | translate }}
                  </span>
                </div>
              </div>
            </div>

            <div class="button__container">
              <div
                class="button__booking"
                (click)="apriDettaglioTipovisita(idx, tipovisita)"
              >
                {{ "base.scopri_btn" | translate }}
                <span class="material-symbols-outlined action-icon">
                  chevron_right
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            tipovisitaSelezionata != null &&
            tipovisitaSelezionata.id == tipovisita.id
          "
          class="dettaglio__mobile"
        >
          <div class="dettaglio__visita">
            <app-tipi-visite-layout-colonne
              [tipivisite]="tipovisitaArray"
              [linguaCorrente]="linguaCorrente"
              [codiceForm]="codiceFormGiusto"
              [codiceFormMaster]="codiceForm"
              [collegate]="collegate"
              [canBack]="true"
              [base]="true"
              (goBack)="tornaIndietro()"
              [cart]="cart"
            >
            </app-tipi-visite-layout-colonne>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dettaglio__desktop" id="dettaglio">
  <div class="collage">
    <div class="tipiWrapper" *ngIf="!tipovisitaSelezionata">
      <div
        class="tipovisita"
        id="tipovisita__{{ idx }}"
        *ngFor="let tipovisita of tipivisite; let idx = index"
        [ngStyle]="{
          background:
            colori && colori.sfondoCardItems ? colori.sfondoCardItems : 'auto'
        }"
      >
        <div class="image__container">
          <div class="tipologie">
            <app-tipologie [tipologie]="tipovisita.tipo"></app-tipologie>
          </div>
          <img
            src="{{ tipovisita.imgsrc }}"
            alt="Immagine copertina visita {{ tipovisita.nome }}"
            title="Immagine copertina visita {{ tipovisita.nome }}"
            class="image__img"
            (click)="apriDettaglioTipovisita(idx, tipovisita)"
          />
          <div class="instant__wrapper">
            <div class="instant promo" *ngIf="tipovisita.visiteInPromo !== '0'">
              PROMO
              <span class="material-symbols-outlined"> sell </span>
            </div>
            <div
              class="instant booking"
              *ngIf="
                tipovisita.totVisite > 0 && tipovisita.confermabile !== '1'
              "
            >
              {{ "base.conferma_istantanea" | translate }}
              <span class="material-symbols-outlined"> bolt </span>
            </div>
            <div
              class="instant pcantina"
              *ngIf="
                tipovisita.totVisite > 0 &&
                tipovisita.pagacantina_visita === '1'
              "
            >
              {{ "base.paga_sc" | translate }}
              <span class="material-symbols-outlined"> credit_card </span>
            </div>
          </div>
        </div>
        <div class="content__container">
          <div>
            <div class="orario-item" *ngIf="collegate">
              {{ tipovisita.cantina }} ({{ tipovisita.regione }})
            </div>
            <div class="title">
              {{ sistemaTitolo(tipovisita.titolo) }}
            </div>
            <div
              class="subtitle"
              *ngIf="tipovisita.sottotitolo && tipovisita.sottotitolo !== ''"
            >
              {{ tipovisita.sottotitolo }}
            </div>
          </div>
          <div class="space__between__container">
            <div class="info__bottom__container">
              <div
                class="orario-item"
                *ngIf="tipovisita.offsetOreCancella != 0"
              >
                <span class="material-symbols-outlined icon">
                  check_circle
                </span>
                {{ "base.cancellazione_gratuita" | translate }}
              </div>
              <div class="orario-item" *ngIf="tipovisita.range_attivi === '1'">
                <span class="material-symbols-outlined icon"> person_add </span>
                {{ "base.range_prezzi" | translate }}
              </div>
              <div
                class="price__container"
                *ngIf="tipovisita.nascondi_prezzo === '0'"
              >
                <div class="from" *ngIf="chooseCostoMinimo(tipovisita) > 0">
                  {{ "base.a_partire" | translate }}
                </div>
                <div class="price">
                  <span *ngIf="chooseCostoMinimo(tipovisita) > 0">€</span>
                  <span *ngIf="chooseCostoMinimo(tipovisita) > 0">
                    {{ chooseCostoMinimo(tipovisita) | number : "1.2-2" }}
                  </span>
                  <span *ngIf="chooseCostoMinimo(tipovisita) == 0">
                    {{ "base.gratis" | translate }}
                  </span>
                </div>
              </div>
            </div>

            <div class="button__container">
              <div
                class="button__booking"
                (click)="apriDettaglioTipovisita(idx, tipovisita)"
              >
                {{ "base.scopri_btn" | translate }}
                <span class="material-symbols-outlined action-icon">
                  chevron_right
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            tipovisitaSelezionata != null &&
            tipovisitaSelezionata.id == tipovisita.id
          "
          class="dettaglio__mobile"
        >
          <div class="dettaglio__visita">
            <app-tipi-visite-layout-colonne
              [tipivisite]="tipovisitaArray"
              [linguaCorrente]="linguaCorrente"
              [codiceForm]="codiceFormGiusto"
              [codiceFormMaster]="codiceForm"
              [collegate]="collegate"
              [canBack]="true"
              [base]="true"
              (goBack)="tornaIndietro()"
              [cart]="cart"
            >
            </app-tipi-visite-layout-colonne>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="tipovisitaSelezionata != null" class="dettaglio__desktop">
  <div class="dettaglio__visita">
    <app-tipi-visite-layout-colonne
      [tipivisite]="tipovisitaArray"
      [linguaCorrente]="linguaCorrente"
      [codiceForm]="codiceFormGiusto"
      [codiceFormMaster]="codiceForm"
      [collegate]="collegate"
      [canBack]="true"
      [base]="true"
      (goBack)="tornaIndietro()"
      [cart]="cart"
    >
    </app-tipi-visite-layout-colonne>
  </div>
</div>

<!-- test -->
